<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: 'Nunito Sans', 'Noto Sans TC';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
